import  {useState, useCallback } from 'react';

export const useCloseUp = () => {
    const [closeUpState, setCloseUpState] = useState({
        isOpen: false,
        id: null,
        index: null,
        title: '',
        image: '',
        commentary: ''
    });

    const openCloseUp = useCallback((id, index, title, image, commentary) => {
        setCloseUpState({
            isOpen: true,
            id,
            index,
            title,
            image,
            commentary
        });
    }, []);

    const closeCloseUp = useCallback(() => {
        setCloseUpState(prev => ({ ...prev, isOpen: false }));
    }, []);

    return { 
        closeUpState, 
        openCloseUp, 
        closeCloseUp 
    };
};
